var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Prop, } from "vue-facing-decorator";
import { CacheHelper } from "@/app/utils/cache-helper";
let VerticalSplitterVue = class VerticalSplitterVue extends Vue {
    constructor() {
        // https://htmldom.dev/create-resizable-split-views/
        super(...arguments);
        // The current position of mouse
        this.x = 0;
        this.y = 0;
        // Width of left side
        this.leftWidth = 0;
        this.lastLeftWidth = 0;
        this.leftPanelVisible = true;
    }
    mounted() {
        this.resizer = document.getElementById('vertical-splitter-div');
        this.leftSide = document.getElementById(this.leftSideElementId);
        this.rightSide = document.getElementById(this.rightSideElementId);
        // Attach the handler
        this.resizer.addEventListener('mousedown', this.mouseDownHandler);
        if (this.id) {
            let width = CacheHelper.getItem("vertical-spplitter-div", this.id);
            if (width) {
                this.setLeftPanelWidth(width);
            }
        }
    }
    ;
    setLeftPanelWidth(width) {
        this.leftSide.style.flex = `0 0 ${width}%`;
        this.leftSide.style.maxWidth = `${width}%`;
        this.lastLeftWidth = width;
        if (this.id) {
            CacheHelper.storeItem("vertical-spplitter-div", this.id, width);
        }
    }
    mouseDownHandler(e) {
        if (!this.leftPanelVisible)
            return;
        // Get the current mouse position
        this.x = e.clientX;
        this.y = e.clientY;
        this.leftWidth = this.leftSide.getBoundingClientRect().width;
        // Attach the listeners to `document`
        document.addEventListener('mousemove', this.mouseMoveHandler);
        document.addEventListener('mouseup', this.mouseUpHandler);
    }
    ;
    mouseMoveHandler(e) {
        // How far the mouse has been moved
        const dx = e.clientX - this.x;
        const dy = e.clientY - this.y;
        let newLeftWidth = ((this.leftWidth + dx) * 100) / this.resizer.parentNode.getBoundingClientRect().width;
        if (this.maxWidth && newLeftWidth > this.maxWidth) {
            newLeftWidth = this.maxWidth;
        }
        this.setLeftPanelWidth(newLeftWidth);
        this.resizer.style.cursor = 'col-resize';
        document.body.style.cursor = 'col-resize';
        this.leftSide.style.userSelect = 'none';
        this.leftSide.style.pointerEvents = 'none';
        this.rightSide.style.userSelect = 'none';
        this.rightSide.style.pointerEvents = 'none';
    }
    ;
    mouseUpHandler() {
        this.resizer.style.removeProperty('cursor');
        document.body.style.removeProperty('cursor');
        this.leftSide.style.removeProperty('user-select');
        this.leftSide.style.removeProperty('pointer-events');
        this.rightSide.style.removeProperty('user-select');
        this.rightSide.style.removeProperty('pointer-events');
        // Remove the handlers of `mousemove` and `mouseup`
        document.removeEventListener('mousemove', this.mouseMoveHandler);
        document.removeEventListener('mouseup', this.mouseUpHandler);
    }
    ;
    hideShowLeftPanel() {
        this.leftPanelVisible = !this.leftPanelVisible;
        let display = this.leftPanelVisible ? "flex" : "none !important";
        this.leftSide.style.cssText = 'display:' + display;
        if (this.lastLeftWidth > 0)
            this.setLeftPanelWidth(this.lastLeftWidth);
        this.resizer.style.cursor = this.leftPanelVisible ? "ew-resize" : "default";
    }
};
__decorate([
    Prop(),
    __metadata("design:type", String)
], VerticalSplitterVue.prototype, "leftSideElementId", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], VerticalSplitterVue.prototype, "rightSideElementId", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Number)
], VerticalSplitterVue.prototype, "maxWidth", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], VerticalSplitterVue.prototype, "hideLeftPanel", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], VerticalSplitterVue.prototype, "id", void 0);
VerticalSplitterVue = __decorate([
    Component({
        name: "VerticalSplitterVue"
    })
], VerticalSplitterVue);
export default VerticalSplitterVue;
